export const TOP_NAV_DATA_GA = {
  logo: 'logo',
  buyingTools: 'buying-tools-navigation',
  topNavigation: 'top-navigation',
};

export const TOP_NAV_DATA_TEST = {
  header: 'header',
  logo: 'logo',
  interestButton: 'interest-button',
  menuButton: 'menu-button',
  buyingToolsNavigation: 'buying-tools-navigation',
  navigation: 'navigation',
  navigationMenuLink: 'navigation-menu-link',
};
